import React from 'react';

import ContactHelper from '../../core/libs/ContactHelper';
import { openUrl, ThirdPartyIcon, ThirdPartyName } from '../../core/libs/utils';
import {
  ThirdPartyIdText,
  ViewContactCaption,
  ViewContactField,
  ViewContactThirdPartyIcon
} from '../styled/ContactsForm';

import { TAppAddress, TAppContact, TAppEmail, TAppPhone, TAppThirdPartyId } from 'TProtocol/common/models';

export default function OtherInfo(props: { contact: TAppContact }) {
  return <>
    {(props.contact.otherEmails) ?
      props.contact.otherEmails.map((email: TAppEmail, idx: number) => {
        return (
          <ViewContactField key={idx}>
            <a href={'mailto:' + email.displayEmail}>{email.displayEmail}</a>
            {email.isInactive ? <ViewContactCaption>Obsolete</ViewContactCaption> : <>
              {email.label ? <ViewContactCaption>{email.label}</ViewContactCaption> : null}
            </>}
          </ViewContactField>
        );
      })
      : ''
    }

    {(props.contact.otherPhones) ?
      props.contact.otherPhones.map((phone: TAppPhone, idx: number) => {
        return (
          <ViewContactField key={idx}>
            <span>{phone.displayNumber}</span>
            {phone.isInactive ? <ViewContactCaption>Obsolete</ViewContactCaption> : <>
              {phone.label ? <ViewContactCaption>{phone.label}</ViewContactCaption> : null}
            </>}
          </ViewContactField>
        );
      })
      : ''
    }

    {(props.contact.otherAddresses) ?
      props.contact.otherAddresses.map((address: TAppAddress, idx: number) => {
        const addressString = ContactHelper.addressString(address);
        const addressLink = <a target="google-maps"
                               href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                 addressString)}`}>{addressString}</a>;

        return (
          <ViewContactField key={idx}>
            <span>{addressLink}</span>
          </ViewContactField>
        );
      })
      : ''
    }

    {(props.contact.otherThirdPartyIds) &&
      props.contact.otherThirdPartyIds.map((thirdPartyId: TAppThirdPartyId, idx: number) => {
        if (thirdPartyId.source && thirdPartyId.value) {
          return (
            <ViewContactField key={idx}>
              <ViewContactThirdPartyIcon alt={ThirdPartyName[thirdPartyId.source]}
                                         src={ThirdPartyIcon[thirdPartyId.source]}/>
              {
                thirdPartyId.url ?
                  <ThirdPartyIdText onClick={() => openUrl(thirdPartyId.url)}>{thirdPartyId.value}</ThirdPartyIdText> :
                  <span>{thirdPartyId.value}</span>
              }
            </ViewContactField>
          );
        }
        return;
      })
    }
  </>;
}
